export * from './pipes';
export * from './models';
export * from './shared.module';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/index.ts